var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("g", [
    _c("path", {
      attrs: {
        d: "M52.953 57L58 51.953l-16.031-16.18.593-1.039c2.376-3.76 3.563-7.817 3.563-12.172 0-6.234-2.202-11.553-6.605-15.957C35.116 2.202 29.797 0 23.562 0 17.328 0 12.01 2.202 7.605 6.605 3.202 11.01 1 16.328 1 22.562c0 6.235 2.202 11.579 6.605 16.032 4.404 4.453 9.723 6.68 15.957 6.68 4.256 0 8.362-1.238 12.32-3.712l1.04-.742L52.953 57zM23.925 40c-4.979 0-9.211-1.75-12.697-5.25C7.743 31.25 6 27 6 22s1.743-9.25 5.228-12.75C14.714 5.75 18.946 4 23.925 4c4.98 0 9.212 1.75 12.697 5.25C40.207 12.85 42 17.1 42 22s-1.793 9.15-5.378 12.75C33.137 38.25 28.905 40 23.925 40z",
        fill: "currentColor",
        "fill-rule": "nonzero",
      },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }